import { useContext } from 'react';

import { IsMobileContext } from '@/lib/providers/IsMobileProvider';

export default function useIsMobile(): boolean {
  return useContext(IsMobileContext);
}
